export default {
  test: {
    path: '/test',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: true,
      data: {
        name: 'demo1'
      }
    }
  },
  // 权限按钮配置
  getPermissionBtn: {
    app: 'cloudStorage',
    path: '/api/menu/pagePermissions',
    method: 'get'
  },
  /* 个人信息修改 */
  info: {
    path: '/api/user/info/modify',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  /* 个人信息展示 */
  show: {
    path: '/api/user/details/search',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 登录
  login: {
    path: '/spacex/login?ajax=true',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  getCode: {
    path: '/api/captcha/generateBase64',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    timeout: 5000
  },
  // 校验验证码
  checkCode: {
    path: '/spacex/captcha/validate',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  // 注册时验证手机号码是否存在
  phoneValidate: {
    path: '/api/user/phone/validate',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'text',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  // 校验手机验证码
  checkPhoneCode: {
    path: '/api/sms/code/check',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'text',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  // 校验图片验证码
  checkPicCode: {
    path: '/captcha/validate',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'text',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  /* 发送验证码 */
  sendMsg: {
    path: '/api/sms/code/send',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 用户注册
  register: {
    path: '/api/user/register',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 密码找回身份认证
  psdIdentity: {
    path: '/api/user/identity/validate',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 重置密码
  reset: {
    path: '/api/user/password/update',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 删除文件／文件夹
  removeFiles: {
    path: '/api/file/removeFiles',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 用户名唯一性验证
  vWebsite: {
    path: '/api/user/website/validate',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 下载单个文件
  unifileD: {
    path: '/api/file/download/single',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 日志查询
  log: {
    path: '/api/log/mine/list',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 日志一键删除
  logsDeteleted: {
    path: '/api/log/mine/removeAll',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 日志单独删除
  logDeteleted: {
    path: '/api/log/mine/remove',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    // traditional: true,
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 回收站的日志查询
  delList: {
    path: '/api/file/delList',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    defaultParam: {
      order: 0,
      type: 'gmt_create'
    },
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 清空已删除文件
  clearRemovedFile: {
    path: '/api/file/clearRemovedFile',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 彻底删除
  permRemove: {
    path: '/api/file/permRemove',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 文件恢复
  recover: {
    path: '/api/file/recover',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 多文件打包下载
  multifilesD: {
    path: '/api/file/download/multi',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 新建文件夹接口
  mKdir: {
    path: '/api/file/mkdir',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 重命名接口
  rename: {
    path: '/api/file/rename',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 个人文件查询接口
  searchFile: {
    path: '/api/file/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 获取文件夹列表
  getFolderLists: {
    path: '/api/file/dir/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 获取历史版本列表
  getVertionLists: {
    path: '/api/fileVersion/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件设置为最新
  setNewest: {
    path: '/api/fileVersion/goBack',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // logoOut
  logout: {
    path: '/spacex/logout',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 某文件的某个版本下载
  versionUnifileD: {
    path: '/api/fileVersion/download/single',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 添加分享
  share: {
    path: '/api/share/publish',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 已分享列表
  sharelist: {
    path: '/api/share/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 分享给同事
  shareWorkmate: {
    path: '/api/assignedShare/save',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 取消分享给同事
  cancelShareWorkmate: {
    path: '/api/assignedShare/cancel',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 取消分享文件
  delateShare: {
    path: '/api/share/delete',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 上传
  simpleUpload: {
    path: '/api/file/simpleUpload',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 上传
  simpleNewUpload: {
    path: '/api/fileVersion/simpleUpload',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 头像上传
  avator: {
    path: '/api/user/avator/upload',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    contentType: 'multipart/form-data'
  },
  // 已收藏列表
  favorite: {
    path: '/api/favorite/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    defaultParam: {
      order: 0,
      type: 'gmt_create'
    }
  },
  // 取消收藏
  removeFavorite: {
    path: '/api/favorite/remove',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 添加收藏
  addFavorite: {
    path: '/api/favorite/add',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件或文件夹移动
  moveFiles: {
    path: '/api/file/move',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件或文件夹复制
  copyFiles: {
    path: '/api/file/copy',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件保存
  saveFiles: {
    path: '/api/share/save',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 是否需要加密
  isPrivate: {
    path: '/api/share/isPrivate',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 查询分享文件
  checkShareFile: {
    path: '/api/share/checkShareFile',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 按目录查询分享文件
  listShareFile: {
    path: '/api/share/listShareFile',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 分享文件下载
  shareDownload: {
    path: '/api/share/download',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json'
  },
  // 共享文件对应全选用户列表
  userList: {
    path: '/api/shareFile/user/list',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json'
  },
  // 共享文件查询
  shareFiles: {
    path: '/api/shareFile/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 文件预览
  preview: {
    path: '/api/file/preview',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json'
  },
  // 新建共享文件夹接口
  mKDir: {
    path: '/api/shareFile/mkDir',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  mkFirstShareDr: {
    path: '/api/shareFile/publish',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 所有用户
  allUser: {
    path: '/api/user/search',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  userCount: {
    path: '/api/shareFile/user/count',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json'
  },
  addUser: {
    path: '/api/shareFile/user/add',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  removeUser: {
    path: '/api/shareFile/user/remove',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件夹目录结构查询
  fileCatalog: {
    path: '/api/file/fileCatalog',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 查询群组列表
  groupList: {
    path: '/api/userGroup/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 删除群组
  deleteGroup: {
    path: '/api/userGroup/remove',
    app: 'cloudStorage',
    method: 'post'
  },
  // 新增群组
  addGroup: {
    path: '/api/userGroup/save',
    app: 'cloudStorage',
    method: 'post'
  },
  // 修改群组
  modifyGroup: {
    path: '/api/userGroup/rename',
    app: 'cloudStorage',
    method: 'post'
  },
  // 成员列表
  memberListByGroup: {
    path: '/api/user/groupUser/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 删除成员
  deleteMember: {
    path: '/api/userGroup/removeUser',
    app: 'cloudStorage',
    method: 'post'
  },
  // 部门列表
  deptList: {
    path: '/api/org/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 根据部门id查成员列表
  memberListByDept: {
    path: '/api/user/orgUser/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 所有用户列表
  allMemberList: {
    path: '/api/user/search',
    app: 'cloudStorage',
    method: 'post'
  },
  // 个人文件搜索
  fileSearch: {
    path: '/api/file/search',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 共享文件搜索
  shareSearch: {
    path: '/api/shareFile/search',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 他人分享搜索
  assignedShare: {
    path: '/api/assignedShare/search',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 新增成员
  addMember: {
    path: '/api/userGroup/addUser',
    app: 'cloudStorage',
    method: 'post'
  },
  // 包含租户的城市列表
  cityList: {
    path: '/api/city/hasTenant/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 包含租户的区域列表
  townList: {
    path: '/api/district/hasTenant/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 查询区域下的租户列表
  addressList: {
    path: '/api/tenant/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 查询租户log
  lesseeLogo: {
    path: '/api/tenant/getLogo',
    app: 'cloudStorage',
    method: 'get'
  },
  // 他人分享
  otherSharelist: {
    path: '/api/assignedShare/receiveUser/file/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 分享给他人的文件
  shareOther: {
    path: '/api/assignedShare/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 删除别人分享给我的文件
  deleteOtherShare: {
    path: '/api/assignedShare/receiveUser/removeFile',
    app: 'cloudStorage',
    method: 'post'
  },
  // 保存别人分享的文件
  saveOtherShare: {
    path: '/api/assignedShare/receiveUser/saveFile',
    app: 'cloudStorage',
    method: 'post'
  },
  // 他人分享预览文件
  otherSharePreview: {
    path: '/api/assignedShare/preview',
    app: 'cloudStorage',
    method: 'get'
  },
  // 他人分享图片预览
  otherShareImg: {
    path: '/api/assignedShare/receiveUser/downloadFile',
    app: 'cloudStorage',
    method: 'get'
  },
  // 记录用户的登陆信息
  record: {
    path: '/api/user/login/record',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false
    }
  },
  // 单点登录
  login2: {
    path: '/api/open/sz/login',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/apis/cloudStorageApi.js